type Props = {
  page: number;
  total: number;
  limit: number;
  onPageChange: (page: number) => void;
};

export function Pagination({ page, total, limit, onPageChange }: Props) {
  const totalPages = Math.max(1, Math.ceil(total / limit));
  const from = total === 0 ? 0 : (page - 1) * limit + 1;
  const to = Math.min(page * limit, total);

  return (
    <div className="pagination">
      <span className="pagination-info">
        {from}–{to} de {total} {total === 1 ? "registro" : "registros"}
      </span>
      <div className="pagination-controls">
        <button
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={() => onPageChange(1)}
          disabled={page <= 1}
          aria-label="Primera página"
        >
          ⏮
        </button>
        <button
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
        >
          ← Anterior
        </button>
        <span className="pagination-page">
          Página <b>{page}</b> de {totalPages}
        </span>
        <button
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
        >
          Siguiente →
        </button>
        <button
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={() => onPageChange(totalPages)}
          disabled={page >= totalPages}
          aria-label="Última página"
        >
          ⏭
        </button>
      </div>
    </div>
  );
}
